'use client';

import { RightArrow } from 'assets/icons';
import {
  ComponentPropsWithoutRef,
  ReactNode,
  useEffect,
  useRef,
  useState,
} from 'react';
import { useWindowSize } from 'hooks/dom/useWindowSize';
import { Container } from './Container';
import styles from './ScrollBasedCarousel.module.css';

export const H3 = ({ className, ...props }: ComponentPropsWithoutRef<'h3'>) => (
  <h3 className={className ? `${styles.h3} ${className}` : styles.h3} {...props} />
);

export const CarousalComponent = ({
  className,
  title,
  data,
}: {
  className?: string;
  title: string;
  data: ReactNode[];
}) => {
  const carousel = useRef<HTMLDivElement>(null);
  const [arrowBtnVisible, setArrowBtnVisible] = useState(true);
  const { width } = useWindowSize();

  function onPrevClick() {
    if (!carousel.current) return;
    carousel.current.scrollLeft -= window.innerWidth / 2;
  }

  function onNextClick() {
    if (!carousel.current) return;
    carousel.current.scrollLeft += window.innerWidth / 2;
  }

  useEffect(() => {
    if (width < 768) {
      if (data.length < 2) setArrowBtnVisible(false);
    } else {
      const arrowButtons =
        data.length < 3
          ? (() => {
              if (data.length === 1) return false;
              const isFull = data.filter((item) =>
                (item as Record<string, any>).props.style.className?.includes(
                  'full',
                ),
              );
              if (isFull.length > 0) return true;
              return false;
            })()
          : true;

      setArrowBtnVisible(arrowButtons);
    }
  }, [width]);

  return (
    <div className={className ? `${styles.carousal} ${className}` : styles.carousal}>
      <Container
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <H3>{title}</H3>
        {arrowBtnVisible ? (
          <div
            className={`${styles.arrowContainer}${
              data.length === 1 ? ` ${styles.dMdNone}` : ''
            }`}
          >
            <div
              className={styles.circleBlurBtn}
              onClick={onPrevClick}
              onKeyDown={onPrevClick}
              role="button"
              tabIndex={0}
            >
              <RightArrow
                fill="#000000"
                style={{
                  transform: 'rotate(180deg)',
                  width: '1.5rem',
                  height: '1.5rem',
                }}
              />
            </div>
            <div
              className={styles.circleBlurBtn}
              onClick={onNextClick}
              onKeyDown={onNextClick}
              role="button"
              tabIndex={0}
            >
              <RightArrow
                fill="#000000"
                style={{ width: '1.5rem', height: '1.5rem' }}
              />
            </div>
          </div>
        ) : null}
      </Container>

      <div className={styles.carousalParent}>
        <div
          className={`${styles.carousalItems} carousal-items${
            data.length < 2 ? ` ${styles.pr0}` : ''
          } u-hide-scrollbar`}
          ref={carousel}
        >
          {data.map((item) => {
            return <>{item}</>;
          })}
        </div>
      </div>
    </div>
  );
};

export const ElementContainer = ({
  className,
  ...props
}: ComponentPropsWithoutRef<'div'>) => (
  <div
    className={className ? `${styles.element} ${className}` : styles.element}
    {...props}
  />
);
